var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeastGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 15V13.4444C13.4444 12.6193 13.1167 11.828 12.5332 11.2445C11.9498 10.6611 11.1585 10.3333 10.3333 10.3333H4.11111C3.28599 10.3333 2.49467 10.6611 1.91122 11.2445C1.32778 11.828 1 12.6193 1 13.4444V15",
    stroke: "#3CA48E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22223 7.22222C8.94044 7.22222 10.3333 5.82933 10.3333 4.11111C10.3333 2.39289 8.94044 1 7.22223 1C5.50401 1 4.11111 2.39289 4.11111 4.11111C4.11111 5.82933 5.50401 7.22222 7.22223 7.22222Z",
    stroke: "#3CA48E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeastGreen);
export default __webpack_public_path__ + "static/media/leastGreen.9c3e301f.svg";
export { ForwardRef as ReactComponent };